export class TimeFormatterFunction {
  static getHoursMinutesSecondsPeriod(momentObj?: moment.Moment) {
    return momentObj ? momentObj.format('h:mm:ss a') : '';
  }
  static defaultTime(momentObj?: moment.Moment) {
    return momentObj ? momentObj.format('ddd, MMM D') : '';
  }
  static monthAndDate(momentObj?: moment.Moment) {
    return momentObj ? momentObj.format('MMMM D') : '';
  }
  static monthAndDateAndYear(momentObj?: moment.Moment) {
    return momentObj ? momentObj.format('MMMM D, YYYY') : '';
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/functions/time_formatter_fn.ts